import React from 'react';

const Modal = ({ isOpen, onClose, title, children, maxWidth = '600px' }) => {
  if (!isOpen) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalStyle = {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '8px',
    maxWidth: maxWidth,
    width: '90%',
    maxHeight: '90vh',
    overflow: 'auto',
    position: 'relative',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#666666',
    padding: '0.5rem',
    lineHeight: '1',
  };

  const titleStyle = {
    color: '#666666',
    marginBottom: '1.5rem',
    fontSize: '1.5rem',
    fontWeight: '500',
    fontFamily: 'Sora, sans-serif',
  };

  const contentStyle = {
    color: '#666666',
    lineHeight: '1.6',
    fontSize: '1rem',
    fontFamily: 'Sora, sans-serif',
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>
        <button style={closeButtonStyle} onClick={onClose} aria-label="Close modal">&times;</button>
        {title && <h2 style={titleStyle}>{title}</h2>}
        <div style={contentStyle}>{children}</div>
      </div>
    </div>
  );
};

export default Modal; 